import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { Product, ProductListByIdsConfigService } from 'gung-standard';
import { CarLinerBrochuresProductListViewComponent } from '../components/car-liner-brochures-product-list-view/car-liner-brochures-product-list-view.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerBrochuresProductListByIdsConfigService extends ProductListByIdsConfigService {

  searchDisabled = true;

  protected searchTermSubject = new BehaviorSubject<string>('');

  setSearchTerm(term: string) {
    this.searchTermSubject.next(term || '');
  }

  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => 'fa fa-list',
        getListItemComponent: () => CarLinerBrochuresProductListViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductGrid'
      }
    ];
  }

  getItems(): Observable<Product[]> {
    return combineLatest([super.getItems(), this.searchTermSubject.asObservable()]).pipe(
      map(([products, searchTerm]) => this.filterBySearchTerm(products, searchTerm)),
      map(m =>
        m.sort((a, b) => {
          const aSort = a.name.toLowerCase();
          const bSort = b.name.toLowerCase();

          if (aSort < bSort) {
            return -1;
          }
          if (aSort > bSort) {
            return 1;
          }
          return 0;
        })
      )
    );
  }

  protected filterBySearchTerm(products: Product[], searchTerm: string): Product[] {
    const query = (searchTerm || '').trim().toLowerCase();
    if (!query) {
      return [...products];
    }

    const queryParts = query.split(/\s+/);
    return products.filter(product => {
      const terms = `${product.id} ${product.name}`.toLowerCase();
      return queryParts.every(part => terms.includes(part));
    });
  }
}
